const tipoSecaoEnum = {
  CAPA: "capa",
  FAQ: "faq",
  SOBRE: "sobre",
  RODAPE: "rodape"
};
  
export default tipoSecaoEnum;
  